// 客户
import CustomList from './base/Index';
import CustomAdd from './base/PageAdd';
import CustomEdit from './base/PageEdit';
import ProjectAdd from './base/PageProAdd';

import CustomCompanyList from './base/company/Index';
import CustomConfig from './company/PageConfig';
import CustomCompanyAdd from './base/company/PageAdd';
import CustomBillList from './base/bill/Index';
import CompanyList from './company/Index';
import CompanyCustomList from './company/custom/Index';

const router = {
  path: 'custom',
  breadcrumbName: '客户',
  childRoutes: [
    {
      path: 'base',
      breadcrumbName: '客户总表',
      indexRoute: { component: CustomList },
      childRoutes: [
        {
          path: 'add',
          breadcrumbName: '新增客户',
          component: CustomAdd,
        },
        {
          path: 'addPro',
          breadcrumbName: '项目信息',
          component: ProjectAdd,
        },
        {
          path: 'edit/:uuid',
          breadcrumbName: '编辑',
          component: CustomEdit,
        },
        {
          path: ':uuid/bill',
          breadcrumbName: '资金列表',
          indexRoute: { component: CustomBillList },
          childRoutes: [],
        },
        {
          path: ':uuid/company',
          breadcrumbName: '公司列表',
          indexRoute: { component: CustomCompanyList },
          childRoutes: [
            {
              path: 'add',
              breadcrumbName: '增加客户公司',
              component: CustomCompanyAdd,
            },
          ],
        },
      ],
    },
    {
      path: 'company',
      breadcrumbName: '公司列表',
      indexRoute: { component: CompanyList },
      childRoutes: [
        /* {
                    path: ':uuid/custom',
                    breadcrumbName:"关联公司",
                    indexRoute: { component: CustomConfig }
                }, */
        {
          path: ':uuid/custom',
          breadcrumbName: '公司客户',
          indexRoute: { component: CompanyCustomList },
          childRoutes: [
            {
              path: 'add',
              breadcrumbName: '关联公司',
              indexRoute: { component: CustomConfig },
            },
          ],
        },
      ],
    },
    {
      path: 'bill',
      breadcrumbName: '资金列表',
      indexRoute: { component: CustomBillList },
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/custom/router.js